module.exports = __webpack_public_path__ + "assets/img/icon_number_of_schools@2x.adaa1cdb.png";